import axios from "axios";
import {
  append_to_dom,
  catch_error,
  get_user_info,
} from "../firebase/functions";
import { error_messages, response_error_messages } from "../consts/messages";
// import { error_messages, response_error_messages } from "../consts/messages";
var is_user_cookbook = false;
var cookbook_recipes = [];
let cookbook_hash_key = window.location.pathname.split("/")[2];
if (cookbook_hash_key == "cookbooks") {
  cookbook_hash_key = window.location.pathname.split("/")[3];
}
var cookbook_recipe_post_id = "";
var cookbook_recipe_index = "";
var cookbook_name = "";
var new_cookbook_name = "";
var user_first_name = "";
var user_last_name = "";

jQuery(document).ready(function ($) {
  if (
    window.location.href.includes("cookbooks") &&
    !window.location.href.includes("my-cookbooks") &&
    cookbook_hash_key
  ) {
    if (localStorage.getItem("user_info")) {
      if (JSON.parse(localStorage.getItem("user_info"))?.cookbooks) {
        for (let i in JSON.parse(localStorage.getItem("user_info"))
          ?.cookbooks) {
          if (
            JSON.parse(localStorage.getItem("user_info"))?.cookbooks[i]
              .hashKey == cookbook_hash_key
          ) {
            is_user_cookbook = true;
            $("#my_cookbooks_filter").css("display", "flex");
            $(".public--cookbook--title img").css("display", "block");
            $(".public--cookbook--title").css("display", "flex");

            cookbook_recipes = JSON.parse(localStorage.getItem("user_info"))
              ?.cookbooks[i].recipes;
            $("#cookbook_recipe_count").text(
              JSON.parse(localStorage.getItem("user_info"))?.cookbooks[i]
                .recipes.length
            );
            $("#cookbook_name").text(
              JSON.parse(localStorage.getItem("user_info"))?.cookbooks[i]
                .categoryName
            );
            cookbook_name = JSON.parse(localStorage.getItem("user_info"))
              ?.cookbooks[i].categoryName;
            $("#cookbook_author_info").css("display", "flex");

            if (
              JSON.parse(localStorage.getItem("user_info"))?.cookbooks[i]
                .isPublic
            ) {
              $("#public-cookbook").attr("checked", true);
            } else {
              $("#private-cookbook").attr("checked", true);
            }

            if (JSON.parse(localStorage.getItem("user_info")).photoURL) {
              $("#cookbook_author_image").attr(
                "src",
                JSON.parse(localStorage.getItem("user_info")).photoURL
              );
            } else {
              $("#cookbook_author_image").attr(
                "src",
                "/wp-content/themes/atyabtabkha/src/assets/images/temp/profile-img.png"
              );
            }

            if (JSON.parse(localStorage.getItem("user_info")).about) {
              $("#cookbook_author_about").text(
                JSON.parse(localStorage.getItem("user_info")).about
              );
            }

            if (
              JSON.parse(localStorage.getItem("user_info")).firstName ||
              JSON.parse(localStorage.getItem("user_info")).lastName
            ) {
              if (JSON.parse(localStorage.getItem("user_info")).firstName) {
                user_first_name = JSON.parse(
                  localStorage.getItem("user_info")
                ).firstName;
              }

              if (JSON.parse(localStorage.getItem("user_info")).lastName) {
                user_last_name = JSON.parse(
                  localStorage.getItem("user_info")
                ).lastName;
              }

              $("#cookbook_author_name").text(
                `${user_first_name} ${user_last_name}`
              );
            } else {
              if (JSON.parse(localStorage.getItem("user_info")).username) {
                $("#cookbook_author_name").text(
                  JSON.parse(localStorage.getItem("user_info")).username
                );
              } else {
                $("#cookbook_author_name").text("مستخدم اطيب طبخة");
              }
            }
            break;
          }
        }
      }
    }

    if (is_user_cookbook) {
      // $("#cookbook_author_info_link").attr(
      //   "href",
      //   `/user/${JSON.parse(localStorage.getItem("user_info")).userID}`
      // );
      let data = `&action=load_cookbook_recipes&public_cookbook_recipes=${JSON.stringify(
        cookbook_recipes
      )}&user_cookbook_recipes=${true}`;
      $.ajax({
        type: "POST",
        dataType: "html",

        url: load_cookbook_recipes.ajaxurl,
        data: data,

        success: function (res) {
          $("#cookbook--recipes--container").append(res);
        },
        error: function (jqXHR, textStatus, errorThrown) {
          console.log(jqXHR);
          console.log(textStatus);
          console.log(errorThrown);
        },
      });

      $("#delete_my_cookbook_page").css("display", "block");
    } else {
      let url = `${savedSettings.api_url}/getUserInfoByCookbook?hashKey=${cookbook_hash_key}`;

      if (cookbook_hash_key) {
        let access_token = JSON.parse(
          localStorage.getItem("login_result")
        )?.access_token;

        axios
          .get(url, {
            headers: {
              "x-api-key": savedSettings.x_api_key,
              Authorization: ` Bearer ${access_token}`,
            },
          })
          .then((res) => {
            $("#cookbook_author_info_link").attr(
              "href",
              `/user/${res.data.data.userInfo.hashKey}`
            );

            $("#cookbook_recipe_count").text(
              res.data.data.cookbookInfo.recipes.length
            );
            cookbook_recipes = res.data.data.cookbookInfo.recipes;
            $("#cookbook_name").text(res.data.data.cookbookInfo.categoryName);

            $("#cookbook_author_info").css("display", "flex");

            $(".public--cookbook--title").css("display", "block");
            if (res.data.data.userInfo.photoURL) {
              $("#cookbook_author_image")
                .attr("src", res.data.data.userInfo.photoURL)
                .attr(
                  "alt",
                  `${res.data.data.userInfo.firstName} ${res.data.data.userInfo.lastName}`
                )
                .addClass("fit-image");
            } else {
              $("#cookbook_author_image")
                .attr(
                  "src",
                  "/wp-content/themes/atyabtabkha/src/assets/images/temp/profile-img.png"
                )
                .addClass("fit-image");
            }

            if (
              res.data.data.userInfo.firstName ||
              res.data.data.userInfo.lastName
            ) {
              if (res.data.data.userInfo.firstName) {
                user_first_name = res.data.data.userInfo.firstName;
              }

              if (res.data.data.userInfo.lastName) {
                user_last_name = res.data.data.userInfo.lastName;
              }

              $("#cookbook_author_name").text(
                `${user_first_name} ${user_last_name}`
              );
            } else {
              if (res.data.data.userInfo.username) {
                $("#cookbook_author_name").text(
                  res.data.data.userInfo.username
                );
              } else {
                $("#cookbook_author_name").text("مستخدم اطيب طبخة");
              }
            }

            if (res.data.data.userInfo.about) {
              $("#cookbook_author_about").text(res.data.data.userInfo.about);
            }
          })
          .then(() => {
            let data = `&action=load_cookbook_recipes&public_cookbook_recipes=${JSON.stringify(
              cookbook_recipes
            )}`;
            $.ajax({
              type: "POST",
              dataType: "html",

              url: load_cookbook_recipes.ajaxurl,
              data: data,

              success: function (res) {
                $("#cookbook--recipes--container").append(res);
              },
              error: function (jqXHR, textStatus, errorThrown) {
                console.log(jqXHR);
                console.log(textStatus);
                console.log(errorThrown);
              },
            });
          })

          .catch((err) => {
            catch_error(err);
            if (err.response) {
              if (err.response.status) {
                if (err.response.status == 403) {
                  window.location.href = "/404";
                }
              }
            }
          });
      }
    }
  }

  $(document).on("click", ".user--cookbook--recipe--remove", function () {
    cookbook_recipe_post_id = $(this).data("post-id");
    cookbook_recipe_index = $(this).data("index");

    append_to_dom(
      "popup-remove-recipe-from-cookbook-open",
      "delete_cookbook_recipe_confirm",
      null
    );
  });

  $(document).on(
    "click",
    "#delete_cookbook_recipe_confirm #recipe_delete_cancel",
    function () {
      cookbook_recipe_post_id = "";
      cookbook_recipe_index = "";
      $("#delete_cookbook_recipe_confirm").remove();
    }
  );

  $(document).on(
    "click",
    "#delete_cookbook_recipe_confirm #recipe_delete_confirm",
    function () {
      $("#delete_cookbook_recipe_confirm #recipe_delete_confirm").addClass(
        "button--loading"
      );
      const url = `${savedSettings.api_url}/cookbook`;

      let body = {
        action: "recipes",
        categoryName: cookbook_name,
        recipeToRemove: `${cookbook_recipe_post_id}` + "",
      };
      axios
        .post(url, body, {
          headers: {
            "x-api-key": savedSettings.x_api_key,
            contentType: "application/json; charset=utf-8",
            Authorization: ` Bearer ${
              JSON.parse(localStorage.getItem("login_result"))?.access_token
            }`,
          },
        })
        .then((res) => {
          get_user_info(false, false, true);
          $("#delete_cookbook_recipe_confirm").remove();
          $(`#author__recipe__${cookbook_recipe_index}`).remove();
          let new_recipe_count = parseInt($("#cookbook_recipe_count").text());
          new_recipe_count--;
          $("#cookbook_recipe_count").text(new_recipe_count);
        })
        .catch((err) => {
          catch_error(err);
          $(
            "#delete_cookbook_recipe_confirm #recipe_delete_confirm"
          ).removeClass("button--loading");
        });
    }
  );

  $("#my_cookbooks_filter input").on("change", function (e) {
    let isPublic = false;
    isPublic = $(this).data("is-public");

    const url = `${savedSettings.api_url}/cookbook`;

    let body = {
      action: "update",
      categoryName: cookbook_name,
      isPublic: isPublic,
    };

    axios
      .post(url, body, {
        headers: {
          "x-api-key": savedSettings.x_api_key,
          contentType: "application/json; charset=utf-8",
          Authorization: ` Bearer ${
            JSON.parse(localStorage.getItem("login_result"))?.access_token
          }`,
        },
      })
      .then((res) => {
        get_user_info(false, false, true);
      })
      .catch((err) => {
        catch_error(err);
      });
  });

  $(".public--cookbook--title img, #cookbook_name").on("click", function () {
    if (is_user_cookbook) {
      $(".cookbook-page-header-form").css("display", "flex");
      $("#cookbook-page-header-form").css("display", "block");
      $("#my_cookbooks_filter").css("display", "none");
      $(".public--cookbook--title").css("display", "none");
    }
  });

  $("#cookbook-page-header-change").val(cookbook_name);

  function cancel_name_change() {
    $(".public--cookbook--title").css("display", "flex");
    $(".cookbook_section__body-head img").css("display", "block");
    $("#cookbook-page-header-form").css("display", "none");
    $("#my_cookbooks_filter").css("display", "flex");
    $("#cookbook_rename_error").text("");
    $("#cookbook-page-header-change").val(cookbook_name);

    $("#cookbook_rename_confirm").prop("disabled", true);
  }

  $("#cookbook-page-header-change").on("keyup input focus", function (e) {
    new_cookbook_name = e.target.value;
    if (new_cookbook_name.length == 0) {
      $("#cookbook_rename_confirm").prop("disabled", true);
    } else {
      $("#cookbook_rename_confirm").prop("disabled", false);
    }
    if (e.key == "Escape" || e.key == "escape") {
      cancel_name_change();
    }
  });

  $("#cookbook_rename_cancel").on("click", function () {
    cancel_name_change();
  });

  $("#cookbook_name_change").on("submit", function (e) {
    e.preventDefault();
    const url = `${savedSettings.api_url}/cookbook`;

    let body = {
      action: "rename",
      categoryName: cookbook_name,
      newCategoryName: new_cookbook_name,
    };
    $("#cookbook_rename_confirm").addClass("button--loading");

    axios
      .post(url, body, {
        headers: {
          "x-api-key": savedSettings.x_api_key,
          contentType: "application/json; charset=utf-8",
          Authorization: ` Bearer ${
            JSON.parse(localStorage.getItem("login_result"))?.access_token
          }`,
        },
      })
      .then(() => {
        $("#cookbook_rename_confirm").removeClass("button--loading");
        get_user_info(false, false, true);
        $("#cookbook-page-header-form").css("display", "none");
        $(".public--cookbook--title").css("display", "flex");
        $("#cookbook-page-header-form").css("display", "none");
        $("#cookbook_rename_error").text("");
        $("#my_cookbooks_filter").css("display", "flex");
        $("#cookbook_name").text(new_cookbook_name);
        cookbook_name = new_cookbook_name;
        $("#cookbook-page-header-change").val(new_cookbook_name);
        $("#cookbook_title").text(
          $("#cookbook_title").text().replace(cookbook_name, new_cookbook_name)
        );

        $(".my_cookbook_recipes a img").attr(
          "data-cookbook-name",
          new_cookbook_name.split(" ").join("_")
        );
      })

      .catch((err) => {
        $("#cookbook_rename_confirm").removeClass("button--loading");
        if (err) {
          if (err.response) {
            if (err.response.data) {
              if (err.response.data.message) {
                if (
                  err.response.data.message.includes(
                    response_error_messages.cookbook_exists
                  )
                ) {
                  $("#cookbook_rename_error").text(
                    error_messages.cookbook_exists
                  );
                }
              }
            }
          }
        }
      });
  });
});
